import React, { useState } from 'react';
// @ts-ignore
import bpop from '../../../assets/audio/b-pop.mp3';
// @ts-ignore
import baskin from '../../../assets/audio/baskin.mp3';
// @ts-ignore
import cinayet from '../../../assets/audio/cinayet.mp3';
// @ts-ignore
import kimimben from '../../../assets/audio/kimim ben.mp3';
// @ts-ignore
import mindtrap from '../../../assets/audio/mind trap.mp3';
// @ts-ignore
import violin from '../../../assets/audio/violin.mp3';
import { MusicPlayer } from '../../general';

export interface MusicProjectsProps {}

const MusicProjects: React.FC<MusicProjectsProps> = (props) => {
    const [currentSong, setCurrentSong] = useState<string>('');

    return (
        <div className="site-page-content">
            <h1>Music & Sound</h1>
            <h3>Ventures</h3>
            <br />
            <div className="text-block">
                <p>
                    Music has been my passion my whole life. I downloaded FL Studio when I was 15 and started making my own music.
                </p>
                <br />
                <p>
                    I don't release the music that I make publicly as I not only
                    find it difficult to finish songs, but also it's not a
                    priority of mine since I produce mostly because I enjoy the
                    process of learning and creating. However if I am going to
                    dedicate a whole page of my portfolio to my music, you bet
                    I'll have some examples to showoff.
                </p>
                <br />
                <p>
                    Below are some more recent Musical Endeavors I've been
                    working on. I hope you enjoy the music and enjoy the stories
                    behind each of the tracks.
                </p>
            </div>
            <h2>Exploring rap</h2>
            <br />
            <p>
In 2022, I went through a period where I really enjoy rap music. So I decided to try making my own rap songs.            </p>
            <br />
            <p>
                I failed a few times as I wasn't really able to nail the style
                and groove I was going for but ultimately ended up creating the
                piece below.
            </p>
            <br />

            <MusicPlayer
                src={baskin}
                title="BASKIN"
                subtitle="Emirhan Bölek"
                currentSong={currentSong}
                setCurrentSong={setCurrentSong}
            />
            <br />
            <h2>My love for RAP</h2>
            <br />
            <p>
                I've always loved drum & bass, and I feel like I've always come back to it over the years. My first song was a rap track, and as I've continued making music over the past few years, the way I produce rap reflects my particular taste at that time. It's fun to look back at the various rap styles I've tried over time and how my taste has evolved. I produced both of the songs below when I was around 15-16 years old.
            </p>
            <br />
            <MusicPlayer
                src={cinayet}
                title="Cinayet"
                subtitle="Emirhan Bölek"
                currentSong={currentSong}
                setCurrentSong={setCurrentSong}
            />
            <br />
            <MusicPlayer
                src={kimimben}
                title="Kimim Ben?"
                subtitle="Emirhan Bölek"
                currentSong={currentSong}
                setCurrentSong={setCurrentSong}
            />
            <br />
            <h2>K-pop?</h2>
            <br />
            <p>
                I experimented a lot with this piece and
I'm very proud of the result to this day.
I just haven't had the chance to finish it and add a proper closing,
but I'm still very happy with how it is.
            </p>
            <br />
            <MusicPlayer
                src={bpop}
                title="B-POP"
                subtitle="Emirhan Bölek"
                currentSong={currentSong}
                setCurrentSong={setCurrentSong}
            />
            <br />

            <br />
            
            <h2>The Future of my music</h2>

            <br />
        
            <p>
                I love to make music and will continue to make music as long as
                I can. I think soon enough I will be releasing music publicly
                since I feel like my personal style has slowly developed into
                something I am proud of over these last few years. I also want
                to one day make an album, but that is a long ways away.
            </p>
            <br />
            <p>
                I am aware this section of my portfolio is rather short, but
                it's because I am very selective with what I want to show off to
                the world. I've been producing for over 6 years and have made
                hundreds maybe even a thousand tracks/loops in that time. I only
                recently have been feeling very content with the stuff I've made
                and I'm very excited to see what I can do for the future. Thanks
                for listening I hope you enjoyed!
            </p>
            <br />
            <MusicPlayer
                src={mindtrap}
                title="MINDTRAP"
                subtitle="Emirhan Bölek"
                currentSong={currentSong}
                setCurrentSong={setCurrentSong}
            />  
               <br />
            <MusicPlayer
                src={violin}
                title="VIOLIN"
                subtitle="Emirhan Bölek"
                currentSong={currentSong}
                setCurrentSong={setCurrentSong}
            />  
        </div>
    );
};

// const styles: StyleSheetCSS = {};

export default MusicProjects;
